'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REACT_SINGLE_CHILD = exports.REACT_CHILDREN = exports.INPUT_OPTIONS_STRUCTURE = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_OPTIONS_STRUCTURE = exports.INPUT_OPTIONS_STRUCTURE = _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
  value: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]).isRequired,
  text: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.number]).isRequired
}));

var REACT_CHILDREN = exports.REACT_CHILDREN = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.array]);

var REACT_SINGLE_CHILD = exports.REACT_SINGLE_CHILD = _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string]);


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/common/PropTypes.js
// module id = 103
// module chunks = 0